import api from '@js/actions/api';

export const fetchTrialStatus = (userId) => (
    api.get(`/api/v1/trial/${userId}`)
);

export const enableUserTrial = (userId) => (
    api.update(`/api/v1/trial/${userId}`)
);

export const disableUserTrial = (userId) => (
    api.delete(`/api/v1/trial/${userId}`)
);
